import Image from "next/image";
import Archiver from "public/images/pricing/business/businessArchiving.svg";
import Trashcan from "public/images/pricing/business/businessTrashcan.svg";
import Scheduler from "public/images/pricing/business/businessScheduler.svg";

const Card = () => {
  return (
    <div className="mt-5 flex w-full items-end justify-center">
      <div className="flex shrink flex-col gap-5 xl:flex-row xl:gap-0">
        <div className="ml-5 flex h-[200px] w-[90%] shrink rounded-lg bg-brand-slate px-5 xl:w-1/3">
          <div className="mt-5 ml-5 flex w-[325px] flex-col">
            <Image
              alt="archiver Icon"
              width={30}
              height={30}
              src={Archiver}
              className="flex w-[30px] items-center"
            />
            <p className="font-bold text-xl">Advanced Archiving Solutions</p>
            <span className="mt-0 text-base text-slate-300">
              Redact will create an archive of your data as its being removed, so you will always be
              compliant with your data retention policies.{" "}
            </span>
          </div>
        </div>
        <div className="ml-5 flex h-[200px] w-[90%] shrink rounded-lg bg-brand-slate px-5 xl:w-1/3">
          <div className="mt-5 ml-5 flex w-[325px] flex-col">
            <Image
              alt="trashcan Icon"
              width={22}
              height={30}
              src={Trashcan}
              className="flex w-[22px] items-center"
            />
            <p className="font-bold text-xl">Robust Deletion Controls</p>
            <span className="mt-0 text-base text-slate-300">
              Delete anything and everything off your organizations pages with the help of one of
              our privacy experts.{" "}
            </span>
          </div>
        </div>
        <div className="ml-5 flex h-[200px] w-[90%] shrink rounded-lg bg-brand-slate px-5 xl:w-1/3">
          <div className="mt-5 ml-5 flex w-[325px] flex-col">
            <Image
              alt="scheduler Icon"
              width={27}
              height={30}
              src={Scheduler}
              className="flex w-[27px] items-center"
            />
            <p className="font-bold text-xl">Automated Deletion Jobs</p>
            <span className="mt-0 text-base text-slate-300">
              Create poweful automatic deletion jobs with Redact's scheduler, ensuring your pages
              only havethe content you want live is allowed.{" "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
